<template>
    <v-group>
        <v-line
                ref="drag_rect"
                @dragstart="rectDragStart"
                @dragmove="rectDragMove"
                @dragend="rectDragEnd"
                @dblclick="showOptionMenu"
                @dbltap="showOptionMenu"
                @tap="() => {}"
                :config="{points: [tl.x, tl.y, tr.x, tr.y, br.x, br.y, bl.x, bl.y], closed: true, draggable: true}"
        ></v-line>
        <v-group>
            <v-line :config="{points: [tl.x, tl.y, tr.x, tr.y], ...line_config}"></v-line>
            <v-line :config="{points: [tr.x, tr.y, br.x, br.y], ...line_config}"></v-line>
            <v-line :config="{points: [br.x, br.y, bl.x, bl.y], ...line_config}"></v-line>
            <v-line :config="{points: [bl.x, bl.y, tl.x, tl.y], ...line_config}"></v-line>
        </v-group>
        <v-circle @dragstart="$emit('move_start')" @dragmove="e => drag('top_left', e)" @dragend="dragEnd"     :config="{x: tl.x, y: tl.y, ...circle_config}"></v-circle>
        <v-circle @dragstart="$emit('move_start')" @dragmove="e => drag('top_right', e)" @dragend="dragEnd"    :config="{x: tr.x, y: tr.y, ...circle_config}"></v-circle>
        <v-circle @dragstart="$emit('move_start')" @dragmove="e => drag('bottom_left', e)" @dragend="dragEnd"  :config="{x: bl.x, y: bl.y, ...circle_config}"></v-circle>
        <v-circle @dragstart="$emit('move_start')" @dragmove="e => drag('bottom_right', e)" @dragend="dragEnd" :config="{x: br.x, y: br.y, ...circle_config}"></v-circle>

        <v-group v-if="!is_operating" :config="group_config">
            <v-image @click="deleteCurtain" @tap="deleteCurtain" :config="{x:0, y:0, width:34, height: 30, ...delete_obj}"></v-image>
            <v-image @click="copyCurtain" @tap="copyCurtain" :config="{x:45, y:0, width:34, height: 30, ...add_obj}"></v-image>
            <v-text @click="deleteCurtain" @tap="deleteCurtain" :config="{x:5, y:42, text:'削除', fontSize:12, fill:'black', ...font_obj}"></v-text>
            <v-text @click="copyCurtain" @tap="copyCurtain" :config="{x:50, y:42, text:'追加', fontSize:12, fill:'black', ...font_obj}"></v-text>
        </v-group>
    </v-group>
</template>

<script>
    import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
    import CONST from '../../../assets/js/const'
    import {loadImage} from '../../../assets/js/loadImageByPromise'
    const {EDIT_CIRCLE_RADIUS, EDIT_RECT_SIZE} = CONST;

    export default {
        name: "EditRect",
        async created() {
            this.delete_obj = await this.image_config('delete');
            this.add_obj = await this.image_config('add');
        },
        data() {
            return {
                EDIT_CIRCLE_RADIUS,
                EDIT_RECT_SIZE,

                is_showing_option_menu: false,
                delete_obj: {},
                add_obj: {},
                font_obj: {fontFamily: '"Yu Gothic UI", "游ゴシック体", YuGothic, "游ゴシック Medium", "Yu Gothic Medium", "游ゴシック", "Yu Gothic", sans-serif'},

                circle_config: {
                    radius: EDIT_CIRCLE_RADIUS,
                    fill: '#eac42b',
                    draggable: true,
                    opacity: 0.5,
                },
                line_config: {
                    stroke: '#eac42b',
                    strokeWidth: 7,
                    opacity: 0.7,
                },

                //選択範囲ドラッグ時に使用 移動開始時の座標を保持する
                position_temp: {
                    x: 0, y: 0,
                    top_left:     {x: EDIT_CIRCLE_RADIUS, y: EDIT_CIRCLE_RADIUS},
                    top_right:    {x: EDIT_RECT_SIZE,     y: EDIT_CIRCLE_RADIUS},
                    bottom_left:  {x: EDIT_CIRCLE_RADIUS, y: EDIT_RECT_SIZE},
                    bottom_right: {x: EDIT_RECT_SIZE,     y: EDIT_RECT_SIZE},
                },

                top_left:     {x: EDIT_CIRCLE_RADIUS, y: EDIT_CIRCLE_RADIUS},
                top_right:    {x: EDIT_RECT_SIZE,     y: EDIT_CIRCLE_RADIUS},
                bottom_left:  {x: EDIT_CIRCLE_RADIUS, y: EDIT_RECT_SIZE},
                bottom_right: {x: EDIT_RECT_SIZE,     y: EDIT_RECT_SIZE},
            }
        },
        computed: {
            ...mapState(['current_image', 'edit_mode', 'rect_width', 'rect_height', 'is_check_pattern', 'is_curtain', 'input_scale', 'konva_stage']),
            ...mapState('simulator', ['editing_id', 'is_operating']),
            ...mapGetters('simulator', ['editing_item']),

            tl: _this => ({x: _this.top_left.x * _this.input_scale,     y: _this.top_left.y * _this.input_scale}),
            tr: _this => ({x: _this.top_right.x * _this.input_scale,    y: _this.top_right.y * _this.input_scale}),
            bl: _this => ({x: _this.bottom_left.x * _this.input_scale,  y: _this.bottom_left.y * _this.input_scale}),
            br: _this => ({x: _this.bottom_right.x * _this.input_scale, y: _this.bottom_right.y * _this.input_scale}),

            group_config: _this => {
                if(!_this.editing_item || !_this.editing_item.image_config) return;

                const rect_left_position = _this.tl.x < _this.bl.x ? _this.tl.x : _this.bl.x;
                const rect_top_position = _this.tl.y < _this.tr.y ? _this.tl.y : _this.tr.y;

                const option_group_size_x = 70;
                const option_group_size_y = 40;

                const pos_x = rect_left_position + _this.editing_item.image_config.width * _this.input_scale / 2 - option_group_size_x / 2;
                const pos_y = rect_top_position + _this.editing_item.image_config.height * _this.input_scale / 2 - option_group_size_y / 2;
                return {x: pos_x, y: pos_y};
            },
        },
        watch: {
            editing_item(item) {
                if (!item) { this.initArea(); return;}
                const { points } = item;
                if (points) Object.keys(points).forEach( s => this[s] = points[s] );
                else this.initArea();
            },
        },
        methods: {
            ...mapMutations(["setModal"]),
            ...mapMutations("simulator", ["updateItem", "setIsOperating", "setIsContinuingLoading", "createTempItem", "updateTempItem"]),
            ...mapActions("simulator", ["removeItemData", "updateItemInfo", "commitTempItem"]),
            ...mapActions(["resetTimer"]),

            deleteCurtain() {
                this.removeItemData(this.editing_id);
            },
            //同じ種類のカーテンの同じ柄を追加する
            //大きさも同じで座標は少し右下に設定
            async copyCurtain() {
                let item_type = this.editing_item.item_type;
                let curtain_type = this.editing_item.curtain_type;
                const rect_width = this.editing_item.rect_width;
                const rect_height = this.editing_item.rect_height;
                const same_texture = this.editing_item.item_data;

                const gap = 50;
                const points = this.editing_item.points;
                const almost_same_position = {
                    top_left:     {x: points.top_left.x + gap, y: points.top_left.y + gap},
                    top_right:    {x: points.top_right.x + gap, y: points.top_right.y + gap},
                    bottom_left:  {x: points.bottom_left.x + gap, y: points.bottom_left.y + gap},
                    bottom_right: {x: points.bottom_right.x + gap, y: points.bottom_right.y + gap},
                };

                this.createTempItem();

                const copied_editing_item = {...this.editing_item};
                delete copied_editing_item.id;
                this.updateTempItem(copied_editing_item);

                //座標を設定
                await this.setIsContinuingLoading(true);
                this.setPosition(almost_same_position);

                //柄を設定
                await this.setIsContinuingLoading(false);
                await this.updateItemInfo({id: this.editing_id, item_data: same_texture});
            },
            async setPosition(points) {
                // const calculated_points = Util.calculatePoint(points);
                this.updateTempItem({points: points});

                await this.commitTempItem();
                this.resetTimer();
                this.setModal('');
            },
            showOptionMenu() {
                if(!this.editing_item || !this.editing_item.image_config) return;
                this.is_showing_option_menu = true;
            },
            async image_config(func_name) {
                const img_obj = await loadImage(`${CONST.BASE_URL}assets/images/active_borders_${func_name}.png`);
                return {image: img_obj};
            },
            drag(point, e) {
                this[point] = {
                    x: e.target.x() * (1 / this.input_scale),
                    y: e.target.y() * (1 / this.input_scale)
                };
                this.$emit('move');
            },
            dragEnd() {
                this.emitPointsInfo();
            },
            rectDragStart(e) {
                const { top_left, top_right, bottom_left, bottom_right } = this;
                this.position_temp = {
                    x: e.target.x(), y: e.target.y(),
                    points: { top_left, top_right, bottom_left, bottom_right }
                };
                this.$emit('move_start');
            },
            rectDragMove(e) {
                const {x, y, points} = this.position_temp;

                const move_x = (x - e.target.x()) * (1 / this.input_scale);
                const move_y = (y - e.target.y()) * (1 / this.input_scale);
                ['top_left', 'top_right', 'bottom_left', 'bottom_right'].forEach(point => {
                    this[point] = {x: points[point].x - move_x, y: points[point].y - move_y}
                });
                this.$emit('move');
            },
            rectDragEnd() {
                const drag_rect = this.$refs.drag_rect.getNode();
                drag_rect.x(0);
                drag_rect.y(0);
                this.emitPointsInfo();
                //drag_rect.x(n)、drag_rect.y(n)でセットしても再描画されないケースがあるようなので親要素側でdraw()させている
                this.$emit('redraw');
            },
            initArea() {
                const points = {
                    top_left:     {x: this.EDIT_CIRCLE_RADIUS, y: this.EDIT_CIRCLE_RADIUS},
                    top_right:    {x: this.EDIT_RECT_SIZE,     y: this.EDIT_CIRCLE_RADIUS},
                    bottom_left:  {x: this.EDIT_CIRCLE_RADIUS, y: this.EDIT_RECT_SIZE},
                    bottom_right: {x: this.EDIT_RECT_SIZE,     y: this.EDIT_RECT_SIZE},
                };
                Object.keys(points).forEach( s => this[s] = points[s] );
            },
            emitPointsInfo() {
                const {top_left, top_right, bottom_left, bottom_right} = this;
                const points = {top_left, top_right, bottom_left, bottom_right};

                this.$emit('move_end', points);
            },
        }
    }
</script>

<style scoped>

</style>
